import { Injectable } from '@angular/core';

type ThemeMode = 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly storageKey = 'livepass-theme-mode';
  private readonly defaultTheme: ThemeMode = 'light';
  currentTheme: ThemeMode = this.defaultTheme;

  initTheme() {
    const saved = this.readSavedTheme();
    this.applyTheme(saved ?? this.defaultTheme, false);
  }

  toggleTheme() {
    const nextTheme: ThemeMode = this.currentTheme === 'dark' ? 'light' : 'dark';
    this.applyTheme(nextTheme);
  }

  isDarkMode(): boolean {
    return this.currentTheme === 'dark';
  }

  readSavedTheme(): ThemeMode | null {
    try {
      const raw = localStorage.getItem(this.storageKey);
      return raw === 'dark' || raw === 'light' ? raw : null;
    } catch {
      return null; // storage blocked (private mode, etc.)
    }
  }

  applyTheme(theme: ThemeMode, persist = true): void {
    this.currentTheme = theme;

    const isDark = theme === 'dark';
    const body = document.body;

    body.classList.remove('theme-light', 'theme-dark');
    body.classList.add(isDark ? 'theme-dark' : 'theme-light');

    if (persist) {
      try {
        localStorage.setItem(this.storageKey, theme);
      } catch {}
    }
  }
}